export default class Settings {
    POSTAL_CODE = "14021-999";
    USE_TABLE = true;

    HEADER_LOGO_FILE_M10 = "dayofflogo720.png";
    HEADER_LOGO_FILE_ELGINPAY = "dayofflogo360.png";
    HOME_LOGO = require("../../assets/dayofflogo.png");

    CUSTOMER_NAME = "Day Off Café";
    CUSTOMER_PREFIX = "day.off";

    CUSTOMER_ADDRESS = "Av. Wladimir Meirelles Ferreira, 1900";
    
    HOME_URL = "https://ribeirao.dayoffcafe.com.br";
    
    CONSUMER_KEY = "ck_d788de11134f400dec60de756e5c940a191c4a28";
    CONSUMER_SECRET = "cs_0ea63866670e9cf09a3f691f712216c774cd47af";
    
    ACTIVE_CATEGORIES = [
        'caixinha-da-equipe',
        'combos',
        'acompanhamentos',
        'para-beber-quente',
        'para-beber-gelado',
        'para-comer-doce',
        'para-comer-salgado',
        'refeicoes',
        'happy-hour',
        'lojinha-do-doc',
        'pascoa',
        'eventos'
        // 'cursos'
    ];
}